<template>
  <div>
    <div class="headerDiv">
      <div style="display:flex ;align-items: center">
        <img v-if="showLeftMenu" src="../assets/logo.png" style="width: auto;height: 60px;" class="logoImg">
        <span class="headerTitle">商务管理系统</span>
        <div style="color: #ecde16;  margin-left: 10px;font-size: 16px;font-family: 'Microsoft YaHei';">(系统使用问题咨询人：各组对应的商务助理；合同相关问题找：程燕)
        </div>
      </div>
      <div style="display: flex;gap: 15px;align-items: center">
        <el-tooltip content="查看当天日期提醒" v-if="reminders.length>0">
          <el-badge :value="reminders.length">
            <el-button size="mini" type="primary" icon="el-icon-date" style="margin-left: 10px" circle
              @click="handleInfo"></el-button>
          </el-badge>
        </el-tooltip>
        <el-tooltip content="添加日期提醒" v-if="['ADMIN','BUSINESS_COMMERCIAL'].includes($store.getters['right/getRole'])">
          <el-button size="mini" type="success" icon="el-icon-date" style="margin-left: 10px" circle
            @click="handleAdd"></el-button>
        </el-tooltip>
        <div v-if="['ADMIN', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'].includes($store.getters['right/getRole'])" class="view-switch">
          <span style="color: white; margin-right: 8px;">{{ isMobileView ? '移动端' : '桌面端' }}</span>
          <el-switch v-model="isMobileView" @change="handleViewModeChange" />
        </div>
        <span v-if="$store.getters['right/getRoleList'].length===1 && user.realName !== '詹海燕'"
          style="margin-left: 10px;font-size: 14px;font-family: 'Microsoft YaHei',serif;color:white">角色：{{roleEnCh[$store.getters["right/getRole"]]}}</span>
        <el-dropdown v-if="$store.getters['right/getRoleList'].length!==1 && user.realName !== '詹海燕'"
          @command="handleUserCom">
          <span class="el-dropdown-link">角色：{{roleEnCh[$store.getters["right/getRole"]]}}<i
              class="el-icon-arrow-down el-icon--right"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="role in $store.getters['right/getRoleList']" :command="role"
              icon="el-icon-user">{{roleEnCh[role]}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span v-if="$store.getters['right/getRoleList'].length===1 && user.realName === '詹海燕'"
          style="font-size: 14px;font-family: 'Microsoft YaHei',serif;color:white">角色：{{roleManager[$store.getters["right/getRole"]]}}</span>
        <el-dropdown v-if="$store.getters['right/getRoleList'].length!==1 && user.realName === '詹海燕'"
          @command="handleUserCom">
          <span class="el-dropdown-link">角色：{{roleManager[$store.getters["right/getRole"]]}}<i
              class="el-icon-arrow-down el-icon--right"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="role in $store.getters['right/getRoleList']" v-if="role!=='SALES_MANAGER'"
              :command="role" icon="el-icon-user">{{roleManager[role]}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown @command="handleCommand" style="margin-left: 10px">
          <span class="el-dropdown-link">{{ this.user.username }}<i
              class="el-icon-arrow-down el-icon--right"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-user" command="info">个人中心</el-dropdown-item>
            <el-dropdown-item icon="el-icon-switch-button" command="exit">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <add-edit-reminder :show-reminder="showAdd" v-if="showAdd" :select-type="type"
      @submit="closeAdd"></add-edit-reminder>
    <reminder-info :show-dialog="showInfo" v-if="showInfo" :select-detail="reminders" :time="date" @submit="closeInfo"
      @complete="refresh"></reminder-info>
  </div>
</template>

<script>

import {getDataInLocalStorage, saveDataToLocalStorage} from "@/utils/localStorage";
import AddEditReminder from "@/components/reminder/AddEditReminder.vue";
import {getRemindersList} from "@/api/dilivery/reminder";
import ReminderInfo from "@/components/reminder/ReminderInfo.vue";
import {roleEnCh, roleManager} from "@/store/right";
import {logout} from "@/api/dilivery";
import store from "@/store";
import { setViewMode, getViewMode, setModeFlag, isMobile } from "@/utils/index";

export default {
  name: "Header",
  components: {ReminderInfo, AddEditReminder},
  data() {
    return {
      timer: null,
      reminderShown:'',
      reminders:[],
      showAdd:false,
      showInfo:false,
      date: '',
      type:'add',
      user: {},
      role: '',
      isCollapse: false,
      activeTag: this.$route.path,
      tags: [],
      maxLength: 7,
      roleManager:roleManager,
      roleEnCh:roleEnCh,
      isMobileView: getViewMode()
    }
  },
  watch: {
    '$route'(newRoute) {
      this.addTag(newRoute)
    },
    'tags'(newVal) {
      if(newVal){
        this.addTag(this.$route)
      }
    },
    'HeaderReminderCalled': {
      handler(newVal) {
        if (newVal) {
          this.$store.commit('right/setHeaderReminderCalled', false); // 重置状态
          this.executeTask()
        }
      },
      immediate: true
    }
  },
  computed: {
    HeaderReminderCalled(){
      return this.$store.getters['right/getHeaderReminderCalled']
    },

    showLeftMenu() {
      return this.$store.getters['dataStatus/getShowLeftMenu']
    },
    currentNav() {
      return this.$route.name.split('/')
    },
    isAtStart() {
      this.$nextTick(()=>{
        return this.$refs.tagContainer.scrollLeft <= 0;
      })
    },
    isAtEnd() {
      this.$nextTick(()=>{
        return this.$refs.tagContainer.scrollLeft >= this.$refs.tagContainer.scrollWidth - this.$refs.tagContainer.clientWidth;
      })
    }
  },
  created() {
    this.user = JSON.parse(getDataInLocalStorage('user'))
    this.reminderShown = getDataInLocalStorage('reminderShown')
    this.date = new Date().toISOString().split('T')[0]
    if(this.tags){
      this.addTag(this.$route)
    }
    this.scheduleTask()
    window.addEventListener('beforeunload', this.clearTimer);
  },
  mounted() {
    if(['ADMIN','BUSINESS_COMMERCIAL'].includes(this.$store.getters['right/getRole'])){
      this.executeTask()
    }
  },
  beforeDestroy() {
    this.clearTimer();
    window.removeEventListener('beforeunload', this.clearTimer);
  },
  methods: {
    async handleViewModeChange(value) {
      setViewMode(value);
      if (value) {
        await this.$router.push('/Contract')
      } else {
        const role = this.$store.getters['right/getRole']
        if (['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'].includes(role)) {
          await this.$router.push('/contractCheck')
        } else if (role === 'BUSINESS_COMMERCIAL') {
          await this.$router.push('/refundInfo')
        } else if (['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES','AUDITOR'].includes(role)) {
          await this.$router.push('/salesContract')
        } else if (['FINANCE', 'CASHIER'].includes(role)) {
          await this.$router.push('/paymentInfo')
        } else if (['LAB', 'TECH'].includes(role)) {
          await this.$router.push('/lexicon')
        } else if (['ANALYSE'].includes(role)) {
          await this.$router.push('/template')
        }
      }
      this.$router.go(0);
    },
    scheduleTask(){
      const nowTemp = new Date().getTime(); //获取当前时间戳
      const now = new Date();
      const timestamp = new Date(now);
      timestamp.setDate(timestamp.getDate() + 1);
      timestamp.setHours(0, 0, 0, 0);
      const tomorrowTemp = timestamp.getTime();
      const residueTemp = tomorrowTemp - nowTemp;
      this.clearTimer()
      this.timer = setTimeout(()=>{
        this.executeTask()
        this.scheduleTask()
      },residueTemp)
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    scrollLeft() {
      this.$refs.tagContainer.scrollLeft -= 300;
    },
    scrollRight() {
      this.$refs.tagContainer.scrollLeft += 300;
    },
    async getReminder() {
      try {
        const res = await getRemindersList(this.user.personUuids[0]);
        if (res.code === 200) {
          this.reminders = res.data.filter(item => {
            return item.doneFlag === 0 && item.remindersTimes && item.remindersTimes[this.date] === false;
          });
        }
      } catch (error) {
        console.log(error);
        this.$messageUi.error('获取日历提醒信息失败');
      }
    },
    handleAdd(){
      this.showAdd = true
    },
    async executeTask() {
      await this.getReminder();
      this.date = new Date().toISOString().split('T')[0];
      this.reminderShown = getDataInLocalStorage('reminderShown');
      this.$nextTick(()=>{
        if (this.reminderShown !== this.date && this.reminders.length > 0) {
          this.handleInfo();
        }
      })
    },
    handleInfo(){
      this.showInfo = true
    },
    closeAdd(type){
      if(type==='confirm'){
        this.getReminder()
      }
      this.$store.commit('right/setReminderHeaderCalled', true);
      this.$nextTick(() => {
        this.showAdd = false
      })
    },
    closeInfo(type){
      this.$nextTick(() => {
        this.showInfo = false
      })
      saveDataToLocalStorage('reminderShown', this.date)
    },
    refresh(type){
      this.$store.commit('right/setReminderHeaderCalled', true);
      this.getReminder()
      if(type === 'all'){
        this.$nextTick(() => {
          this.showInfo = false
        })
      }
    },
    async handleUserCom(role) {
      if (role !== this.$store.getters["right/getRole"]) {
        this.$store.commit('right/setRole', role)
        setModeFlag(role)
        if (isMobile()) {
          await this.$router.push('/Contract')
        } else {
          if (['ADMIN', 'MANAGER', 'APPROVAL_SPECIALIST'].includes(role)) {
            await this.$router.push('/contractCheck')
          } else if (role === 'BUSINESS_COMMERCIAL') {
            await this.$router.push('/refundInfo')
          } else if (['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES','AUDITOR'].includes(role)) {
            await this.$router.push('/salesContract')
          } else if (['FINANCE', 'CASHIER'].includes(role)) {
            await this.$router.push('/paymentInfo')
          } else if (['LAB', 'TECH'].includes(role)) {
            await this.$router.push('/lexicon')
          } else if (['ANALYSE'].includes(role)) {
            await this.$router.push('/template')
          }
        }
        this.$router.go(0)
        this.$store.commit('dataStatus/setInit')
      } else {
        this.$messageUi.success('当前已是该角色')
      }
    },
    changeLeftNav() {
      this.$store.commit('dataStatus/setShowLeftMenu')
    },
    handleCommand(command) {
      if (command === 'info') {
        this.$router.push('/info')
      } else {
        logout().then(res => {
          if (res.code === 200) {
            store.commit('right/setInit')
          }
        })
        this.$router.push('/login')
      }
    },
    addTag(route) {
      if (!this.tags.find(tag => tag.path === route.path)) {
        if (this.tags.length === this.maxLength) {
          this.tags.shift();
        }
        this.tags.push({ path: route.path, name: route.name, label: route.meta.title || route.name })
      }
      this.activeTag = route.path
    },
    handleTagRemove(path) {
      this.tags = this.tags.filter(tag => tag.path !== path)
      if (this.activeTag === path) {
        const newActiveTag = this.tags[this.tags.length - 1]
        this.activeTag = newActiveTag ? newActiveTag.path : '/'
        this.$router.push(this.activeTag)
      }
    },
    setCurrentTag(path) {
      this.activeTag = path
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>

.headerDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  /*height: 100%;*/
  height: 60px;
  padding: 0px;

}

.el-dropdown-link {
  color: #FFFFFF;
  margin-right: 30px;
  cursor: pointer;

}


.routerTag {
  cursor: pointer;
}

.routerTag:hover {
  background-color: #5ba8f5;
  color: white;
}

.logoImg {
  width: 20%;
  margin-left: 30px;
  border-radius: 50px;
}
.headerTitle {
  margin-left: 10px;
  font-size: 28px;
  color: #FFFFFF;
  font-family: "Microsoft YaHei";
}
.view-switch {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.view-switch span {
  font-size: 14px;
  font-family: 'Microsoft YaHei';
}
</style>
